var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('router-link',{attrs:{"to":"/invoice/create"}},[_c('img',{attrs:{"alt":"申请开票","src":require("../assets/invoice_ico.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }